import React from "react";
import { Route, Switch } from "react-router-dom";

import asyncComponent from "util/asyncComponent";

const App = () => (
  <div className="gx-main-content-wrapper">
    <Switch>
    <Route
        path={`/dashboard`}
        component={asyncComponent(() => import("../views/Dashboard"))}
      />
      <Route
        path={`/profile`}
        component={asyncComponent(() => import("../views/ProfileClient"))}
      />
      <Route
        path={`/candidates`}
        component={asyncComponent(() => import("../views/ListCandidates"))}
      />
      <Route
        path={`/results-exams`}
        component={asyncComponent(() => import("../views/ListExamsFinalized"))}
      />
    </Switch>
  </div>
);

export default App;
